import { defineComponent, ref, watch, nextTick, onMounted, openBlock, createElementBlock, normalizeStyle, normalizeClass, renderSlot, createCommentVNode, createElementVNode, createBlock, withCtx, toDisplayString, createVNode, unref, withModifiers } from "vue";
import { useResizeObserver } from "@vueuse/core";
import CloseIcon from "../../assets/icons/x-close.svg.js";
import Tooltip from "../tooltip/Tooltip.vue.js";
const _hoisted_1 = {
  key: 0,
  class: "elfie-badge__prefix"
};
const _hoisted_2 = { class: "elfie-badge__label" };
const _hoisted_3 = {
  key: 1,
  class: "elfie-badge__suffix"
};
const _hoisted_4 = {
  key: 2,
  class: "elfie-badge__close-icon"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Badge",
  props: {
    label: {},
    variant: {},
    disabled: { type: Boolean, default: false },
    size: { default: "md" },
    rounded: { default: "full" },
    textColor: {},
    backgroundColor: {},
    borderColor: {},
    closeable: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const textRef = ref(null);
    const isTruncated = ref(false);
    const checkTruncated = () => {
      if (textRef.value) {
        isTruncated.value = textRef.value.scrollWidth > textRef.value.clientWidth;
      }
    };
    watch(
      () => props.label,
      () => {
        nextTick(checkTruncated);
      }
    );
    onMounted(() => {
      checkTruncated();
    });
    useResizeObserver(textRef, () => {
      checkTruncated();
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("span", {
        class: normalizeClass(["elfie-badge", [
          props.variant ? `elfie-badge--${props.variant}` : "",
          `elfie-badge--${props.size}`,
          `rounded--${props.rounded}`,
          { "elfie-badge--disabled": props.disabled }
        ]]),
        style: normalizeStyle(
          !props.variant ? {
            color: props.textColor,
            background: props.backgroundColor,
            border: props.borderColor ? `1px solid ${props.borderColor}` : void 0
          } : void 0
        )
      }, [
        _ctx.$slots.prefix ? (openBlock(), createElementBlock("span", _hoisted_1, [
          renderSlot(_ctx.$slots, "prefix", {}, void 0, true)
        ])) : createCommentVNode("", true),
        createElementVNode("span", _hoisted_2, [
          _ctx.$slots.label ? renderSlot(_ctx.$slots, "label", { key: 0 }, void 0, true) : (openBlock(), createBlock(Tooltip, {
            key: 1,
            content: props.label || "",
            disabled: !isTruncated.value,
            position: "top"
          }, {
            default: withCtx(() => [
              createElementVNode("div", {
                ref_key: "textRef",
                ref: textRef,
                class: "elfie-badge__label-text"
              }, toDisplayString(props.label), 513)
            ]),
            _: 1
          }, 8, ["content", "disabled"]))
        ]),
        _ctx.$slots.suffix ? (openBlock(), createElementBlock("span", _hoisted_3, [
          renderSlot(_ctx.$slots, "suffix", {}, void 0, true)
        ])) : createCommentVNode("", true),
        props.closeable ? (openBlock(), createElementBlock("span", _hoisted_4, [
          createVNode(unref(CloseIcon), {
            class: "close--icon",
            onClick: _cache[0] || (_cache[0] = withModifiers(($event) => emit("close", $event), ["stop"]))
          })
        ])) : createCommentVNode("", true)
      ], 6);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Badge.vue2.js.map
